import { render } from "./MenuDropdown.vue?vue&type=template&id=24676ea4&scoped=true&ts=true"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts"

import "./MenuDropdown.vue?vue&type=style&index=0&id=24676ea4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24676ea4"]])

export default __exports__